<template>
  <main>
    <section>
      <div class="align-content-center m-4">
        <div class="page_title" style="display: flex;justify-content: center;">
          <div>
            <h3 class="page_title" style="display: inline-block;
                  height: 4.1rem;
                  border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">About Us </h3>
          </div>
        </div>
      </div>
      <div style=" height: 30px;background-color: #2C2C2B;text-align: left;; line-height: 30px;">
        <div class="custom-header" style=" display: flex;text-align: center;">

        </div>
      </div>
    </section>
    <section>
      <!-- <div style="width: 100%;margin: 0 auto;" > 
      <hr>
      <div v-for="(item,index) in currentImg" :key="index">
        <img :src="item.url" alt="">
      </div>
     
    </div> -->
      <div style="width: 100%;margin: 0 auto;">
        <table style="width: 100%;background-color: #1D1D1B;margin: 0 auto;min-height: 800px;">
          <tr>
            <td class="col-md-1-1"
              style="vertical-align: top; padding: 0;background-color: transparent;border-right: 1px solid #424242;">
              <section style="background-color: transparent;">
                <table style="width: 100%;">
                  <tr>
                    <td>
                      <div class="tree-box" style="width: 100%;min-width: 200px;">

                        <div class="tree-content" style="margin-top: 5px;overflow: hidden;">
                          <el-tree ref="treeleft" :data="treeData" node-key="id" :indent="0" class="tree-line"
                            :row-style="{'padding-top':'0px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
                            :default-expand-all="true" :highlight-current="false" :expand-on-click-node="false"
                            @node-click="handleNodeClick">
                            <span slot-scope="{ data }" class="custom-tree-node">
                              <template>
                                <div class="node_div">
                                  <span class="name-box">
                                    {{ data.name }}
                                  </span>
                                </div>
                              </template>
                            </span>
                          </el-tree>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </section>
            </td>
            <td class="container col-md-10-1"
              style="vertical-align: top;padding-top: 30px;text-align: center;font-family: 'dengxian', serif;font-size: 15px;">
              <div v-if="firstPage">
                <img src="/assets/img/About/about101.png" alt="" style="width: 1040px;height: 520px;">
                <div style="height: 50px;"></div>
                <img src="/assets/img/About/about102.png" alt="" style="width: 1040px;height: 520px;">
                <div style="display: flex;justify-content: center;">
                  <div
                    style="text-align: left;width: 1060px;height:auto;font-family: 'dengxian', serif;font-size: 15px;">
                    <br>
                    <br>
                    <p style="font-size: 25px;font-weight: bold;">SanMak lighting Co.,Ltd</p>
                    <div style="height: 10px;"></div>
                    <p>
                      Founded in 2015, Foshan Sanmak Lighting is a high-tech enterprise & SNE in Guangdong Province,
                      specializing in automotive electronics and automotive lighting.
                      Sanmak factory locates in Lishui Town, Nanhai District, Foshan City, with a business area of over
                      15000 square meters, more than 200 employees, and above 100 million
                      RMB annual value output. Ranking in the top three segmented industries, Sanmak’s products are
                      widely used in the application fields of new energy, off-road,
                      engineering, agricultural machinery, military, police, ships, etc.
                    </p>
                    <br>
                    <p>
                      Sanmak independent informatization construction, data linkage, and 100% online office. We attaches
                      great importance to team building in R&D, sales, production systems, quality and supply chain, and
                      recruits talents; Sanmak insists on independent innovation, and continuously launches new
                      generations
                      of lighting, electronics and auxiliary systems. We have accumulated many high-quality and
                      representative customers in the vehicle and after-sales markets.
                    </p>
                    <br>
                    <p>
                      Sanmak has implenmented the quality management system for the design,production and sale of car
                      lighting and accessories compliant with IATF16949 & ISO14001. We also joined the United Nations
                      Global
                      Compact. We say that SANMAK is a Chinese manufacture of lighting used in the automotive industry .
                      We
                      design our products by ourselves and manufacture them .We own our laboratory, mold/injection
                      molding/bonding/wiring harness/assembly workshops, and all optical/electronic core components are
                      self-researched or self-produced, which provides customers with convenient collaborative
                      development,
                      process control, and stable quality product output;
                    </p>
                    <br>
                    <p>
                      90% of Sanmak products are exported to Europe, America, Australia and other developed countries
                      and
                      regions, serving numerous domestic and foreign OEMs and brand merchants. Sanmak adheres to the
                      tenet
                      of rigorous, pragmatic and detail-oriented, adhering to the quality policy of "Craftsmanship
                      spirit,
                      continuous improvement, full quality product delivery, exceeding customer expectations", and
                      continuously improves the management system to provide customers with better service.

                    </p>
                    <br>
                  </div>

                </div>
                <div style="display: flex;justify-content: center;margin-top: 20px;">
                  <div style="display: flex;justify-content: flex-start;width: 1060px;height:auto;">
                    <div style="width: 100px;text-align: left;width: 20%;">
                      <div style="color: #FCB42E;font-size: 32px;font-weight: bold;">
                        15<span style="font-size: 12px;font-weight: normal;">+</span></div>
                      <div>Establishment</div>
                    </div>
                    <div style="width: 100px;text-align: left;width: 20%;">
                      <div style="color: #FCB42E;font-size: 32px;font-weight: bold;">
                        15000<span style="font-size: 12px;font-weight: normal;">m²</span></div>
                      <div>Area</div>
                    </div>
                    <div style="width: 100px;text-align: left;width: 20%;">
                      <div style="color: #FCB42E;font-size: 32px;font-weight: bold;">
                        200<span style="font-size: 12px;font-weight: normal;">+</span></div>
                      <div>Employee</div>
                    </div>
                    <div style="width: 100px;text-align: left;width: 20%;">
                      <div style="color: #FCB42E;font-size: 32px;font-weight: bold;">
                        45<span style="font-size: 12px;font-weight: normal;">+</span></div>
                      <div>R&D Personnel</div>
                    </div>
                    <div style="width: 100px;text-align: left;width: 20%;">
                      <div style="color: #FCB42E;font-size: 32px;font-weight: bold;">
                        150<span style="font-size: 12px;font-weight: normal;">+</span></div>
                      <div>Certificate</div>
                    </div>
                  </div>
                </div>
                <div style="text-align: center;margin-top: 90px;font-size: 28px;margin-bottom: 60px;font-weight: bold;">
                  Enterprise Overview
                </div>
                <div style="display: flex;justify-content: center;">
                  <div style="width: 480px;">
                    <div
                      style="background-image: url('../assets/img/about/about103.png');background-repeat: no-repeat;height: 105px;display: flex;align-items: center;">
                      <div style="text-align: left;padding-left: 135px;">
                        <p style="color: #FCB42E;font-size: 18px;font-weight: bold;">Established in 2010</p>
                        <p style="line-height: 15px;">Rich industry experience and resources have been accumulated</p>
                      </div>
                    </div>
                  </div>

                  <div
                    style="width: 480px;background-image: url('../assets/img/about/about104.png');background-repeat: no-repeat;height: 105px;display: flex;align-items: center;">
                    <div style="text-align: right;padding-right: 140px;width: 100%;">
                      <p style="color: #FCB42E;font-size: 18px;font-weight: bold;">Three major product categories</p>
                      <p style="line-height: 15px;">Vehicle lighting fixtures/warning fixtures</p>
                      <p style="line-height: 15px;">signal fixtures</p>
                    </div>
                  </div>
                </div>
                <div style="display: flex;justify-content: center;margin-top: 40px;">

                  <div style="width: 530px;">
                    <div
                      style="background-image: url('../assets/img/about/about105.png');background-repeat: no-repeat;height: 105px;display: flex;align-items: center;">
                      <div style="text-align: left;padding-left: 135px;">
                        <p style="color: #FCB42E;font-size: 18px;font-weight: bold;">A.O.V. ≥One hundred million</p>
                        <p style="line-height: 15px;">One of the competitive units in the automotivelighting niche
                          market</p>
                      </div>
                    </div>
                  </div>

                  <div
                    style="width: 530px;background-image: url('../assets/img/about/about106.png');background-repeat: no-repeat;height: 105px;display: flex;align-items: center;background-position: right;">
                    <div style="text-align: right;padding-right: 135px;width: 100%;">
                      <p style="color: #FCB42E;font-size: 18px;font-weight: bold;">≥6% of the annual R&D investment</p>
                      <p style="line-height: 15px;">Tianyancha's Sanmak score for Science</p>
                      <p style="line-height: 15px;">and technology innovation was 96 points,</p>
                      <p style="line-height: 15px;">ranking first in the sub-field</p>
                    </div>
                  </div>
                </div>
                <div style="display: flex;justify-content: center;margin-top: 40px;">
                  <div style="width: 480px;">
                    <div
                      style="background-image: url('../assets/img/about/about107.png');background-repeat: no-repeat;height: 105px;display: flex;align-items: center;">
                      <div style="text-align: left;padding-left: 135px;">
                        <p style="color: #FCB42E;font-size: 18px;font-weight: bold;">Employee size≥200</p>
                        <p style="line-height: 15px;">A positive and upward working atmosphere promotes the common
                          development of the enterprise
                          and its employees</p>
                      </div>
                    </div>
                  </div>

                  <div
                    style="width: 480px;background-image: url('../assets/img/about/about108.png');background-repeat: no-repeat;height: 105px;display: flex;align-items: center;">
                    <div style="text-align: right;padding-right: 140px;width: 100%;">
                      <p style="color: #FCB42E;font-size: 18px;font-weight: bold;">Serve the global market</p>
                      <p style="line-height: 15px;">The export proportion is 90%, and it provides </p>
                      <p style="line-height: 15px;">high-quality automotive lighting products to </p>
                      <p style="line-height: 15px;">over 50 countries</p>
                    </div>
                  </div>
                </div>
                <div style="text-align: center;margin-top: 90px;font-size: 28px;margin-bottom: 60px;font-weight: bold;">
                  Corporate Vision
                </div>
                <div style="display: flex;justify-content: center;margin-top: 20px;">
                  <div style="display: flex;justify-content: flex-start;width: 1060px;height:auto;">
                    <div><img src="/assets/img/About/about109.png" alt="" style="width: 515px;height: 320px;">
                    </div>
                    <div style="align-items: center;display: flex;padding-left: 15px;padding-right: 15px;"><img
                        src="/assets/img/About/about110.png" alt="" style="height: 252px;width: 36px;">
                    </div>
                    <div
                      style="text-align: left;max-width: 480px;line-height: 20px;display: grid;align-items: center;max-height: 305px;">
                      <p style="padding-top: 5px;">
                        Committed to becoming a specialized, refined, distinctive and innovative
                        hidden championin the automotive lighting niche market;
                      </p>
                      <p>
                        Build a global brand image and management tools;
                      </p>
                      <p>
                        Achieving success for customers is the sole reason for Sanjin's existence.
                      </p>
                      <p>
                        Realize employees' pursuits and undertake social responsibilities.
                      </p>
                    </div>
                  </div>
                </div>

                <div style="text-align: center;margin-top: 90px;font-size: 28px;margin-bottom: 60px;font-weight: bold;">
                  Lighting Industry Pioneer
                </div>
                <div style="display: grid;justify-content: center;">

                  <div
                    style="background-image: url('../assets/img/about/about111.png');background-repeat: no-repeat;height: 395px;width: 1145px;">
                    <div
                      style="display: flex;justify-content: center;height: 220px;padding-top: 90px;padding-left: 0px;padding-right: 0px;font-size: 18px;line-height: 20px;">
                      <div style="width: 385px;text-align: center;">
                        <p>Excellent R&D team make Sanmak product</p>
                        <p>ahead of the LED lighting industry.</p>
                      </div>
                      <div style="width: 385px;text-align: center;">
                        <p>Modern testing equipments like Integrating </p>
                        <p>Sphere, Salty Spray etc. imported</p>
                        <p>from overseas.</p>
                      </div>
                      <div style="width: 385px;text-align: center;">
                        <p>Advanced injection molding machines, cnc</p>
                        <p>and electroplating processes enable sanmak</p>
                        <p> to have a strong production capacity</p>
                      </div>
                    </div>
                    <div
                      style="display: flex;justify-content: center;height: 150px;padding-top: 140px;padding-left: 0px;padding-right: 0px;font-size: 18px;line-height: 20px;">
                      <div style="width: 385px;text-align: center;">
                        <p>Standardized quality control system to ensure</p>
                        <p>the correct drawings, process control and 8D</p>
                        <p>report</p>
                      </div>
                      <div style="width: 385px;text-align: center;">
                        <p>Convenient ERP to deal with all kinds of data</p>
                        <p>and management for every department.</p>
                      </div>
                      <div style="width: 385px;text-align: center;">
                        <p>Professional OEM/ODM experie-nce to serve</p>
                        <p> the global superior customers.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="text-align: center;margin-top: 90px;font-size: 28px;margin-bottom: 60px;font-weight: bold;">
                  Sales Map
                </div>
                <div style="display: flex;justify-content: center;">
                  <div
                    style="width: 1158px;height: 822px;background-image: url('../assets/img/about/about112.png');background-repeat: no-repeat;">
                  </div>
                </div>

              </div>

              <div v-if="secondPage">
                <div style="display: flex; justify-content: center; align-items: center;">
                  <div
                    style="width: 836px;height: 180px;background-image: url('../assets/img/about/about200.png');background-repeat: no-repeat;background-position: center;width: 830px;height: 1860px;margin-top: 50px;font-size: 14px;">
                    <div style="display: flex;justify-content: left;align-items: center;margin-top: 85px;">
                      <div
                        style="width: 280px;height: 156px;border-radius: 4px;text-align: left;background-image: url('../assets/img/about/about201.png');background-repeat: no-repeat">
                        <div
                          style="font-size: 18px;font-weight: bold; width: 100%;text-align: center;margin-top: 70px;">
                          OPTICS</div>
                        <div style="line-height: 15px;padding-left: 15px;">New Generation Lighting Was Upgraded
                          Production Launch Soon</div>
                      </div>
                      <div style="font-size: 40px;font-weight: bold;color: #FCB42E; padding-left: 15px;">
                        2023
                      </div>
                    </div>
                    <div style="display: flex;justify-content: right;align-items: center;">
                      <div style="font-size: 40px;font-weight: bold;color: #FCB42E; padding-right: 15px;">
                        2022
                      </div>
                      <div
                        style="width: 280px;height: 156px;border-radius: 4px;text-align: left;padding-right: 0px;background-image: url('../assets/img/about/about202.png');background-repeat: no-repeat">
                        <div
                          style="font-size: 18px;font-weight: bold; width: 100%;text-align: center;margin-top: 70px;">
                          SPNI</div>
                        <div style="line-height: 15px;padding-left: 15px;">First Batch Obtain Guangdong SRDI Enterprises
                        </div>
                      </div>

                    </div>
                    <div style="display: flex;justify-content: left;align-items: center;">
                      <div
                        style="width: 280px;height: 156px;border-radius: 4px;text-align: left;background-image: url('../assets/img/about/about203.png');background-repeat: no-repeat">
                        <div
                          style="font-size: 18px;font-weight: bold; width: 100%;text-align: center;margin-top: 70px;">
                          SUPPLIER</div>
                        <div style="line-height: 15px;padding-left: 15px;">Offer Lighting Solution To Chinese Vehicle
                          Manufacturer As Tier-1 Supplier(XPENG MOTORS, Great Wall, LGMG)</div>
                      </div>
                      <div style="font-size: 40px;font-weight: bold;color: #FCB42E; padding-left: 15px;">
                        2020
                      </div>
                    </div>
                    <div style="display: flex;justify-content: right;align-items: center;">
                      <div style="font-size: 40px;font-weight: bold;color: #FCB42E; padding-right: 15px;">
                        2019
                      </div>
                      <div
                        style="width: 280px;height: 156px;border-radius: 4px;padding-right: 0px;text-align: left;background-image: url('../assets/img/about/about204.png');background-repeat: no-repeat">
                        <div
                          style="font-size: 18px;font-weight: bold; width: 100%;text-align: center;margin-top: 70px;">
                          Service</div>
                        <div style="line-height: 15px;padding-left: 15px;">Service Famous Global Company As Tier-2
                          Supplier</div>
                      </div>

                    </div>
                    <div style="display: flex;justify-content: left;align-items: center;">
                      <div
                        style="width: 280px;height: 156px;border-radius: 4px;text-align: left;background-image: url('../assets/img/about/about205.png');background-repeat: no-repeat">
                        <div
                          style="font-size: 18px;font-weight: bold; width: 100%;text-align: center;margin-top: 70px;">
                        OEM  
                        </div>
                        <div style="line-height: 15px;padding-left: 15px;">
                          Service Famous Global Company As Tier-2Supplier
IATF16949/ISO9001/ISO14001/ISO45001
                        </div>
                      </div>
                      <div style="font-size: 40px;font-weight: bold;color: #FCB42E; padding-left: 15px;">
                        2018
                      </div>
                    </div>
                    <div style="display: flex;justify-content: right;align-items: center;">
                      <div style="font-size: 40px;font-weight: bold;color: #FCB42E; padding-right: 15px;">
                        2017
                      </div>
                      <div
                        style="width: 280px;height: 156px;border-radius: 4px;padding-right: 0px;text-align: left;background-image: url('../assets/img/about/about206.png');background-repeat: no-repeat">
                         <div
                          style="font-size: 18px;font-weight: bold; width: 100%;text-align: center;margin-top: 70px;">
                        LAUNCHED
                        </div>
                        <div style="line-height: 15px;padding-left: 15px;">
                          LED Driving Lights Were Launched To Market
                        </div>
                      </div>

                    </div>
                    <div style="display: flex;justify-content: left;align-items: center;">
                      <div
                        style="width: 280px;height: 156px;border-radius: 4px;text-align: left;background-image: url('../assets/img/about/about207.png');background-repeat: no-repeat">
                         <div
                          style="font-size: 18px;font-weight: bold; width: 100%;text-align: center;margin-top: 70px;">
                        TIER-2 SUPPLIER
                        </div>
                        <div style="line-height: 15px;padding-left: 15px;">
                         <p>Signal & Warning Light Series Were</p>  
                         <p>Launched To Marketservicing Famous</p>
                         <p>Global Companies As Tier-2 Supplier</p>
                        </div>
                      </div>
                      <div style="font-size: 40px;font-weight: bold;color: #FCB42E; padding-left: 15px;">
                        2016
                      </div>
                    </div>
                    <div style="display: flex;justify-content: right;align-items: center;">
                      <div style="font-size: 40px;font-weight: bold;color: #FCB42E; padding-right: 15px;">
                        2015
                      </div>
                      <div
                        style="width: 280px;height: 156px;border-radius: 4px;padding-right: 0px;text-align: left;background-image: url('../assets/img/about/about208.png');background-repeat: no-repeat">
                         <div
                          style="font-size: 18px;font-weight: bold; width: 100%;text-align: center;margin-top: 70px;">
                        ERP
                        </div>
                        <div style="line-height: 15px;padding-left: 15px;">
                          Sanmak ERP System Was Developed And  Established.Start Of The Full-Flow Factory 
                          <p>In Foshan City</p>
                        </div>
                      </div>

                    </div>
                    <div style="display: flex;justify-content: left;align-items: center;">
                      <div
                        style="width: 280px;height: 156px;border-radius: 4px;text-align: left;background-image: url('../assets/img/about/about209.png');background-repeat: no-repeat">
                         <div
                          style="font-size: 18px;font-weight: bold; width: 100%;text-align: center;margin-top: 70px;">
                        DIVERSIFICATION
                        </div>
                        <div style="line-height: 15px;padding-left: 15px;">
                         Multiple Work Light Series Was Created
                        </div>
                      </div>
                      <div style="font-size: 40px;font-weight: bold;color: #FCB42E; padding-left: 15px;">
                        2012
                      </div>
                    </div>
                    <div style="display: flex;justify-content: right;align-items: center;">
                      <div style="font-size: 40px;font-weight: bold;color: #FCB42E; padding-right: 15px;">
                        2011
                      </div>
                      <div
                        style="width: 280px;height: 156px;border-radius: 4px;padding-right: 0px;text-align: left;background-image: url('../assets/img/about/about210.png');background-repeat: no-repeat">
                         <div
                          style="font-size: 18px;font-weight: bold; width: 100%;text-align: center;margin-top: 70px;">
                        LED
                        </div>
                        <div style="line-height: 15px;padding-left: 15px;">
                         The First LED Work Light: Cooperate With Famous Companies In AF Marketing.
                        </div>
                      </div>

                    </div>
                    <div style="display: flex;justify-content: left;align-items: center;">
                      <div
                        style="width: 280px;height: 156px;border-radius: 4px;text-align: left;background-image: url('../assets/img/about/about211.png');background-repeat: no-repeat">
                         <div
                          style="font-size: 18px;font-weight: bold; width: 100%;text-align: center;margin-top: 70px;">
                        HID
                        </div>
                        <div style="line-height: 15px;padding-left: 15px;">
                         HID Product Launch To The Market, Sanmak Becomes A Trademark.
                        </div>
                      </div>
                      <div style="font-size: 40px;font-weight: bold;color: #FCB42E; padding-left: 15px;">
                        2010
                      </div>
                    </div>
                    <div style="display: flex;justify-content: right;align-items: center;">
                      <div style="font-size: 40px;font-weight: bold;color: #FCB42E; padding-right: 15px;">
                        2008
                      </div>
                      <div
                        style="width: 280px;height: 156px;border-radius: 4px;padding-right: 0px;text-align: left;background-image: url('../assets/img/about/about212.png');background-repeat: no-repeat">
                         <div
                          style="font-size: 18px;font-weight: bold; width: 100%;text-align: center;margin-top: 70px;">
                        Set up
                        </div>
                        <div style="line-height: 15px;padding-left: 15px;">
                        Sanmak Was Founded As A Supply Chain Management Company 
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
              <div v-if="thirdPage">
                <div style="display: flex; justify-content: center; align-items: center;">
                  <div
                    style="background-image: url('../assets/img/about/about31.png');background-repeat: no-repeat;background-position: center;width: 1218px;height: 632px;margin-top: 65px;">
                    <div style="padding-top: 12px;padding-left: 3px;">General Manager's Office</div>
                    <div style="display: flex;justify-content: left;padding-top: 95px;">
                      <div style="margin-left: 52px;">Sales Department</div>
                      <div style="margin-left: 75px;">Finance Department</div>
                      <div style="margin-left: 70px;"> R&D Department </div>
                      <div style="margin-left: 51px;">Software Department </div>
                      <div style="margin-left: 36px;">Admin & HR Department</div>
                      <div style="margin-left: 23px;">Process Department </div>
                      <div style="margin-left: 32px;">Sanmak-Thailand</div>
                    </div>
                    <div style="display: flex;justify-content: left;padding-top: 86px;">
                      <div style="margin-left: 10px;">International </div>
                      <div style="margin-left: 31px;">Chinese Market </div>
                      <div style="margin-left: 38px;">Product Department</div>
                      <div style="margin-left: 53px;">R&D Department </div>
                      <div style="margin-left: 40px;">Engineering Department</div>
                      <div style="margin-left: 27px;">Production Department</div>
                      <div style="margin-left: 35px;">Quality Department</div>
                      <div style="margin-left: 29px;">Supply chain </div>
                    </div>
                    <div style="display: flex;justify-content: left;padding-top: 106px;">
                      <div
                        style="margin-left: 12px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Supporting Facilities & OEM</div>
                      <div
                        style="margin-left: 25px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Channels & Supermarkets</div>
                      <div
                        style="margin-left: 48px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        OE Matching</div>
                      <div
                        style="margin-left: 26px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        After-sales service & channels</div>
                      <div
                        style="margin-left: 65px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Product Manager</div>
                      <div
                        style="margin-left: 14px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Industrial design </div>
                      <div
                        style="margin-left: 14px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Patent project</div>
                      <div
                        style="margin-left: 32px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Project Management</div>
                      <div
                        style="margin-left: 14px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Structural design</div>
                      <div
                        style="margin-left: 14px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Electronic & Software Design</div>
                      <div
                        style="margin-left: 14px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Optical design</div>
                      <div
                        style="margin-left: 14px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Sample preparation & management</div>
                      <div
                        style="margin-left: 32px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        NPI</div>
                      <div
                        style="margin-left: 15px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        PIE</div>
                      <div
                        style="margin-left: 15px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Lean management & management </div>
                      <div
                        style="margin-left: 38px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Mold making</div>
                      <div
                        style="margin-left: 14px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Injection molding & Electroplating</div>
                      <div
                        style="margin-left: 14px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        SMT</div>
                      <div
                        style="margin-left: 14px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Wiring harness</div>
                      <div
                        style="margin-left: 14px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Assembly</div>
                      <div
                        style="margin-left: 33px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        SQE</div>
                      <div
                        style="margin-left: 14px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        IQC/OQC/IPQC</div>
                      <div
                        style="margin-left: 14px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        SQM/DQE</div>
                      <div
                        style="margin-left: 29px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        PMC</div>
                      <div
                        style="margin-left: 15px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Procurement </div>
                      <div
                        style="margin-left: 15px;writing-mode: vertical-rl;display: flex;justify-content: center;height: 256px;">
                        Warehouse</div>
                    </div>
                    <div></div>
                  </div>
                </div>
              </div>
              <div v-if="fourthPage">
                <div style="display: flex; justify-content: center; align-items: center;">
                  <div
                    style="background-image: url('../assets/img/about/about70.png');background-repeat: no-repeat;background-position: center;width: 1242px;height: 642px;margin-top: 35px;font-size: 15px;">
                    <div style="display: flex;justify-content: left;padding-top: 30px;height: 300px;">
                      <div style="width: 380px;text-align: left; padding-left: 27px;">
                        <div style="font-size: 20px;font-weight: bold; color: #FCB42E;">
                          A Complete Processing Chain
                        </div>
                        <div style="margin-top: 30px;">
                          Molds, injection molding, surface mount technology (SMT), wiring harnesses and assembly are
                          all efficiently completed in our factory. A continuous and efficient production process is
                          formed throughout the entire process from raw material procurement to the final delivery of
                          finished products.
                        </div>
                      </div>
                      <div style="width: 55px;"></div>
                      <div style="width: 380px;text-align: left;padding-left: 27px;">
                        <div style="font-size: 20px;font-weight: bold; color: #FCB42E;">
                          A Pragmatic Management Team
                        </div>
                        <div style="margin-top: 30px;">
                          When dealing with work, maintain a highly serious attitude and pay attention to details.
                          Strictly abide by all kinds of rules and regulations, work processes and quality standards to
                          ensure the smooth progress of each production link.
                        </div>
                      </div>
                      <div style="width: 55px;"></div>
                      <div style="width: 380px;text-align: left;padding-left: 27px;">
                        <div
                          style="font-size: 20px;font-weight: bold; color: #FCB42E;line-height: 25px;margin-top: -18px;">
                          Requirement Analysis，Project
                          Management And R&D
                        </div>
                        <div style="margin-top: 30px;">
                          Adhere to comprehensive and rigorous project management and technical implementation methods.
                          Complete the project on time and in accordance with quality requirements, and provide
                          customers with high-quality products and services.
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;justify-content: left;padding-top: 78px;height: 300px;">
                      <div style="width: 380px;text-align: left; padding-left: 27px;">
                        <div style="font-size: 20px;font-weight: bold; color: #FCB42E;">
                          Equality, Integrity And Service
                        </div>
                        <div style="margin-top: 30px;">
                          Do not exaggerate the advantages of products or services, and do not conceal existing problems
                          and risks. Establish a good corporate image through long-term and consistent honest behavior.
                        </div>
                      </div>
                      <div style="width: 55px;"></div>
                      <div style="width: 380px;text-align: left;padding-left: 27px;">
                        <div style="font-size: 20px;font-weight: bold; color: #FCB42E;">
                          Data Processing Capability
                        </div>
                        <div style="margin-top: 30px;">
                          Based on the results of data analysis, provide intelligent suggestions and solutions for the
                          production decisions of enterprises. Realize intelligent production, optimize production
                          processes, and enhance production efficiency and product quality.

                        </div>
                      </div>
                      <div style="width: 55px;"></div>
                      <div style="width: 380px;text-align: left;padding-left: 27px;">
                        <div style="font-size: 20px;font-weight: bold; color: #FCB42E;line-height: 25px;">
                          A People-Oriented Corporate Culture
                        </div>
                        <div style="margin-top: 30px;">
                          Regard employees as the most core assets of the enterprise, and build the enterprise values,
                          management systems and business philosophy around the needs, development and well-being of
                          employees. By uniting the team's strength, promote the continuous development of the
                          enterprise.
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div style="display:flex;justify-content: center;margin-top: 100px;">
                  <div style="width: 1242px;">
                    <div style="text-align: left;font-size: 24px;font-weight: bold;">
                      Sanmak's Strategy And Tactics
                    </div>
                    <div style="display: flex;justify-content: left;margin-top: 50px;">
                      <div
                        style="background-image: url('../assets/img/about/about71.png');background-repeat: no-repeat;width: 65px;height: 61px;">
                      </div>
                      <div style="display: flex;align-items: center;padding-left: 20px;">
                        <div style="text-align: left;">
                          <p style="font-size: 22px;font-weight: bold;">Positioning</p>
                          <p>Focus on the niche market of vehicle lamps, adhere to the main business, and avoid
                            diversification.</p>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;justify-content: left;margin-top: 40px;">
                      <div
                        style="background-image: url('../assets/img/about/about72.png');background-repeat: no-repeat;width: 65px;height: 61px;">
                      </div>
                      <div style="display: flex;align-items: center;padding-left: 20px;">
                        <div style="text-align: left;">
                          <p style="font-size: 22px;font-weight: bold;">Corporate Image</p>
                          <p>Openness, transparency, internationalization, and no closed office.</p>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;justify-content: left;margin-top: 40px;">
                      <div
                        style="background-image: url('../assets/img/about/about73.png');background-repeat: no-repeat;width: 65px;height: 61px;">
                      </div>
                      <div style="display: flex;align-items: center;padding-left: 20px;">
                        <div style="text-align: left;">
                          <p style="font-size: 22px;font-weight: bold;">Innovation</p>
                          <p>Systematic planning, rapid iteration, no plagiarism, and no R&D divorced from customer
                            value;</p>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;justify-content: left;margin-top: 40px;">
                      <div
                        style="background-image: url('../assets/img/about/about74.png');background-repeat: no-repeat;width: 65px;height: 61px;">
                      </div>
                      <div style="display: flex;align-items: center;padding-left: 20px;">
                        <div style="text-align: left;">
                          <p style="font-size: 22px;font-weight: bold;">Software</p>
                          <p>Autonomous informatization, data-driven decision-making</p>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;justify-content: left;margin-top: 40px;">
                      <div
                        style="background-image: url('../assets/img/about/about75.png');background-repeat: no-repeat;width: 65px;height: 61px;">
                      </div>
                      <div style="display: flex;align-items: center;padding-left: 20px;">
                        <div style="text-align: left;">
                          <p style="font-size: 22px;font-weight: bold;"> Qualification</p>
                          <p> Strictly implement system management and refrain from formalism.</p>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;justify-content: left;margin-top: 40px;">
                      <div
                        style="background-image: url('../assets/img/about/about76.png');background-repeat: no-repeat;width: 65px;height: 61px;">
                      </div>
                      <div style="display: flex;align-items: center;padding-left: 20px;">
                        <div style="text-align: left;">
                          <p style="font-size: 22px;font-weight: bold;"> Team</p>
                          <p> Build a collaborative and problem-solving management team;</p>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;justify-content: left;margin-top: 40px;">
                      <div
                        style="background-image: url('../assets/img/about/about77.png');background-repeat: no-repeat;width: 65px;height: 61px;">
                      </div>
                      <div style="display: flex;align-items: center;padding-left: 20px;">
                        <div style="text-align: left;">
                          <p style="font-size: 22px;font-weight: bold;"> Production Equipment</p>
                          <p> Continuous intelligent transformation to achieve a professional one-stop processing chain;
                          </p>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;justify-content: left;margin-top: 40px;">
                      <div
                        style="background-image: url('../assets/img/about/about78.png');background-repeat: no-repeat;width: 65px;height: 61px;">
                      </div>
                      <div style="display: flex;align-items: center;padding-left: 20px;">
                        <div style="text-align: left;">
                          <p style="font-size: 22px;font-weight: bold;"> Replication</p>
                          <p> Global layout, compliant operation, maintaining the original manufacturing location;</p>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;justify-content: left;margin-top: 40px;">
                      <div
                        style="background-image: url('../assets/img/about/about79.png');background-repeat: no-repeat;width: 65px;height: 61px;">
                      </div>
                      <div style="display: flex;align-items: center;padding-left: 20px;">
                        <div style="text-align: left;">
                          <p style="font-size: 22px;font-weight: bold;"> Quality</p>
                          <p> Products from sanmak are always of high quality.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="fifthPage">
                <div style="display: flex; justify-content: center; align-items: center;">
                  <div style="width: 1160px;margin-top: 20px;">
                    <div style="font-size: 28px;text-align: left;">
                      <p>Independently develop an ERP system</p>
                      <p>Decision-making has shifted from "experience-driven" to "data-driven".</p>
                    </div>
                    <div
                      style="background-image: url('../assets/img/about/about40.png');background-repeat: no-repeat;background-position: center;width: 940px;height: 680px;margin-top: 120px;font-size: 20px;">
                      <div>Delivery Management</div>
                      <div style="display: flex;justify-content: baseline;margin-top: 130px;">
                        <div style="width: 50%;text-align: left;">Supply Chain Management</div>
                        <div style="width: 50%;text-align: right;">CRM Management</div>
                      </div>
                      <div style="display: flex;justify-content: baseline;margin-top: 130px;">
                        <div style="width: 50%;text-align: left;">RM Management</div>
                        <div style="width: 50%;text-align: right;">OA Management</div>
                      </div>
                      <div style="display: flex;justify-content: baseline;margin-top: 130px;">
                        <div style="width: 50%;text-align: left;">FMS Management</div>
                        <div style="width: 50%;text-align: right;">Projects Management</div>
                      </div>
                      <div style="margin-top: 130px;">R&D Management</div>
                    </div>

                    <div style="height: 90px;border-bottom: #2C2C2B solid 1px;"></div>
                    <div style="margin-top: 65px;display: flex;justify-content: left;align-items: center;">
                      <div style="width: 20px;height: 20px;border-radius: 50%;background-color: #FCB42E;"></div>
                      <div style="margin-left: 5px;font-size: 24px;font-weight: bold;">Data integration and governance
                      </div>
                    </div>
                    <div style="font-weight: bold;text-align: left;margin-top: 40px;">1.Data Connectivity</div>
                    <div style="text-align: left;">ERP system by integrating DATA of core business modules such as
                      finance, production, SALES,
                      ETC, to achieve real-time synchronization of data across departments‌.</div>
                    <div style="font-weight: bold;text-align: left;margin-top: 30px;">2.Data standardization and quality
                      control ‌</div>
                    <div style="text-align: left;">Ensure the accuracy and completeness of decision data by unifying
                      data collection standards‌.
                    </div>
                    <div style="margin-top: 50px;display: flex;justify-content: left;align-items: center;">
                      <div style="width: 20px;height: 20px;border-radius: 50%;background-color: #FCB42E;"></div>
                      <div style="margin-left: 5px;font-size: 24px;font-weight: bold;">
                        The application of data-driven decision-making
                      </div>
                    </div>
                    <div style="font-weight: bold;text-align: left;margin-top: 40px;">‌1.Production planning and
                      scheduling ‌</div>
                    <div style="text-align: left;">Demand forecast ‌ : Generate accurate demand forecast ‌ by combining
                      historical sales data with
                      market trend analysis.
                      Smart Scheduling ‌ : Generate the optimal production plan based on multiple constraints such as
                      order requirements, equipment capacity, and material inventory. ‌</div>
                    <div style="font-weight: bold;text-align: left;margin-top: 30px;">2‌.Supply chain optimization</div>
                    <div style="text-align: left;">
                      Purchasing Decision : Develop the best purchasing strategy ‌ by analyzing data such as supplier
                      quotations, delivery cycles, inventory turnover rates, etc.
                      Inventory Management ‌: Dynamically adjust safety stock levels based on sales forecasts and
                      material requirements planning to reduce overstock and out-of-stock risks.
                    </div>
                    <div style="margin-top: 50px;display: flex;justify-content: left;align-items: center;">
                      <div style="width: 20px;height: 20px;border-radius: 50%;background-color: #FCB42E;"></div>
                      <div style="margin-left: 5px;font-size: 24px;font-weight: bold;">
                        Technical support and value realization
                      </div>
                    </div>
                    <div style="font-weight: bold;text-align: left;margin-top: 40px;"> 1.Big data dynamic
                      decision-making‌</div>
                    <div style="text-align: left;">Data-driven ‌: Intelligent analysis of scenarios such as equipment
                      failure prediction and
                      process optimization through data collection, driving decision-making from
                      "experience-driven" to "data-driven".</div>
                    <div style="font-weight: bold;text-align: left;margin-top: 30px;">2‌.Decision-making efficiency and
                      cost optimization</div>
                    <div style="text-align: left;">
                      Improved yield ‌ Real-time monitoring and process optimization can reduce defective yield‌‌.
                      Reduced operating costs: Precise scheduling reduces equipment idleness, procurement strategy
                      optimization reduces raw material costs?
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="sixthdPage">
                <div style="font-size: 28px;margin-bottom: 60px;width: 100%;display: grid;justify-content: center;">
                  <div style="width: 1280px;text-align: left;">
                    <p>Seventeen years of dedication to the field of automotive lighting</p>
                    <p>Passed multiple global certifications</p>
                  </div>
                  <div
                    style="background-image: url('../assets/img/about/about61.png');background-repeat: no-repeat;width: 240px;height: 64px;margin-top: 65px;margin-bottom: 50px;">
                  </div>
                  <div
                    style="background-image: url('../assets/img/about/about62.png');background-repeat: no-repeat;width: 1160px;height: 342px;">

                  </div>
                  <div style="display: flex;justify-content: left;width: 1160;padding-top: 20px;font-size: 22px;">
                    <div style="width: 255px;">IATF16949</div>
                    <div style="width: 50px;"></div>
                    <div style="width: 255px;">ISO 9001</div>
                    <div style="width: 50px;"></div>
                    <div style="width: 255px;">ISO 14001</div>
                    <div style="width: 50px;"></div>
                    <div style="width: 255px;">ISO 45001</div>
                  </div>
                  <div style="text-align: left;padding-top: 120px;">
                    <p>Secured numerous domestic and international patent certifications.</p>
                    <p>A highly professional R&D team delivers high-quality products.</p>
                  </div>
                  <div style="display: flex;justify-content: center;margin-top: 60px;margin-bottom: 50px;">
                    <div style="display: flex;justify-content: flex-start;width: 1260px;height:auto;">
                      <div style="width: 100px;text-align: left;width: 25%;">
                        <div style="color: #FCB42E;font-size: 32px;font-weight: bold;">
                          150<span style="font-size: 12px;font-weight: normal;">+</span></div>
                        <div style="font-size: 16px;">Design Patent</div>
                      </div>
                      <div style="width: 100px;text-align: left;width: 25%;">
                        <div style="color: #FCB42E;font-size: 32px;font-weight: bold;">
                          48<span style="font-size: 12px;font-weight: normal;">+</span></div>
                        <div style="font-size: 16px;">Utility Model Patent</div>
                      </div>
                      <div style="width: 100px;text-align: left;width: 25%;">
                        <div style="color: #FCB42E;font-size: 32px;font-weight: bold;">
                          5<span style="font-size: 12px;font-weight: normal;">+</span></div>
                        <div style="font-size: 16px;">Software Copyright</div>
                      </div>
                      <div style="width: 100px;text-align: left;width: 25%;">
                        <div style="color: #FCB42E;font-size: 32px;font-weight: bold;">
                          5<span style="font-size: 12px;font-weight: normal;">+</span></div>
                        <div style="font-size: 16px;">R&D Personnel</div>
                      </div>
                    </div>
                  </div>
                  <div
                    style="background-image: url('../assets/img/about/about63.png');background-repeat: no-repeat;width: 1260px;height: 393px;background-position: center;">
                  </div>
                </div>
              </div>
              <div v-if="seventhPage">
                <div>
                  <div style="display: flex; justify-content: center; align-items: center;">
                    <div style="width: 1346px;margin-top: 25px;text-align: left;font-size: 27px;">
                      <p>Actively fulfill social responsibilities</p>
                      <p>And became an ESG company</p>

                    </div>
                  </div>
                </div>
                <div style="display: flex; justify-content: center; align-items: center;">
                  <div
                    style="background-image: url('../assets/img/about/about50.png');background-repeat: no-repeat;background-position: center;width: 1346px;height: 254px;margin-top: 65px;">
                  </div>
                </div>
                <div style="display: flex; justify-content: center; align-items: center;">
                  <div style="display: flex; justify-content: left;padding-top: 25px;width: 1346px;">
                    <div style="text-align: left; width: 410px;">
                      <div style="font-size: 28px;font-weight: bold;color: #FCB42E;">Environment</div>
                      <div style="display: flex;justify-content: left;margin-top: 25px;">
                        <div style="width: 15px;height: 15px;background-color: #FCB42E;margin-top: 5px;"></div>
                        <div style="padding-left: 10px;">
                          <p>Sustainable product solutions, including energy-saving</p>
                          <p>design, sustainable materials, energy efficiency solutions and </p>
                          <p>zero-emission solutions for a circular economy.</p>
                        </div>
                      </div>
                      <div style="display: flex;justify-content: left; margin-top: 15px;">
                        <div style="width: 15px;height: 15px;background-color: #FCB42E;margin-top: 5px;"></div>
                        <div style="padding-left: 10px;">
                          <p>Explore the use of new energy for processing and production</p>
                          <p>to promote the utilization rate of new energy in future </p>
                          <p>production.</p>
                        </div>
                      </div>
                    </div>
                    <div style="text-align: left; width: 410px;margin-left: 60px;">
                      <div style="font-size: 28px;font-weight: bold;color: #FCB42E;">Social</div>
                      <div style="display: flex;justify-content: left;margin-top: 25px;">
                        <div style="width: 15px;height: 15px;background-color: #FCB42E;margin-top: 5px;"></div>
                        <div style="padding-left: 10px;">
                          <p>Responsible employers promote gender diversity and</p>
                          <p>inclusiveness and strive to attract talent.</p>
                        </div>
                      </div>
                      <div style="display: flex;justify-content: left; margin-top: 15px;">
                        <div style="width: 15px;height: 15px;background-color: #FCB42E;margin-top: 5px;"></div>
                        <div style="padding-left: 10px;">
                          <p>A learning organization that encourages employee training</p>
                          <p>and development.</p>
                        </div>
                      </div>
                      <div style="display: flex;justify-content: left; margin-top: 15px;">
                        <div style="width: 15px;height: 15px;background-color: #FCB42E;margin-top: 5px;"></div>
                        <div style="padding-left: 10px;">
                          <p>Support the local community through foundations and </p>
                          <p>charitable organizations in education, mobility and the</p>
                          <p>environment.</p>
                        </div>
                      </div>
                    </div>
                    <div style="text-align: left; width: 410px;margin-left: 60px;">
                      <div style="font-size: 28px;font-weight: bold;color: #FCB42E;">Governance</div>
                      <div style="display: flex;justify-content: left;margin-top: 25px;">
                        <div style="width: 15px;height: 15px;background-color: #FCB42E;margin-top: 5px;"></div>
                        <div style="padding-left: 10px;">
                          <p>Stable and sustainable governance.</p>
                        </div>
                      </div>
                      <div style="display: flex;justify-content: left; margin-top: 15px;">
                        <div style="width: 15px;height: 15px;background-color: #FCB42E;margin-top: 5px;"></div>
                        <div style="padding-left: 10px;">
                          <p>Strictly respect compliance.</p>
                        </div>
                      </div>
                      <div style="display: flex;justify-content: left; margin-top: 15px;">
                        <div style="width: 15px;height: 15px;background-color: #FCB42E;margin-top: 5px;"></div>
                        <div style="padding-left: 10px;">
                          <p>A safe working environment.</p>
                        </div>
                      </div>
                      <div style="display: flex;justify-content: left; margin-top: 15px;">
                        <div style="width: 15px;height: 15px;background-color: #FCB42E;margin-top: 5px;"></div>
                        <div style="padding-left: 10px;">
                          <p>Responsible supply chain.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="eighthPage">
                  <div style="display: grid;place-items: center;background-color: #1D1D1B;">
                    <div style="text-align: left;width: 1320px;">
                        <div style="font-size: 30px;font-weight: bold;margin-top: 40px;">{{currentRow.firstTitle}}</div>
                        <!-- <div style="width: 100%;text-align: center;color: #FCB42E;font-size: 18px;font-weight: bold;margin-top: 80px;">{{currentRow.secondTitle}}</div>
                        <div style="width: 100%;text-align: right;color: #949494;font-size: 13px;margin-top: 15px;">{{currentRow.thirdTitle}}</div>
                        <div style="height: 4px;border: 1px solid;background-color: white;margin-top: 5px;"></div> -->
                        <div v-html="currentRow.content" class="preview" style="margin-top: 80px;"></div>
                    </div>
                </div>
              </div>
              <div style="height: 80px;"></div>
            </td>
          </tr>
        </table>
      </div>
    </section>

  </main>
</template>

<script>

  import { getDataInfo ,getRecruitData} from "@/api/rbac/about";
  export default {
    data() {
      return {

        treeData: [],
        currentImg: [],
        firstPage: true,
        secondPage: false,
        thirdPage: false,
        fourthPage: false,
        fifthPage: false,
        sixthdPage: false,
        seventhPage: false,
        eighthPage: false,
        currentRow: { id: 0, firstTitle: '', secondTitle: '', thirdTitle: '', content: '', remark: '' },
      };
    },
    computed: {
      // displayedCertificate() {
      //   const start = this.certificateCurrentPage;
      //   const end = start + this.certificateItemsPerPage;
      //   return this.certificate.slice(start, end);
      // },

      // displayedCourse() {
      //   const start = this.courseCurrentPage;
      //   const end = start + this.courseItemsPerPage;
      //   return this.course.slice(start, end);
      // }

    },
    methods: {
      navigateTo() {
        this.$router.push(`${this.$route.path}/name`);
      },
      next() {
        // 切换到下一张
        if (this.courseCurrentPage < this.course.length - this.courseItemsPerPage) {
          this.courseCurrentPage += 1
        }
      },
      prev() {
        // 切换到上一张
        if (this.courseCurrentPage > 0) {
          this.courseCurrentPage -= 1
        }
      },
      goToSlide(index) {
        // 跳转到指定图片
        this.certificateCurrentPage = index;
      },
      getStyle(index) {
        // 动态设置每张图片的位置
        const total = this.certificate.length;
        const offset = index - this.certificateCurrentPage;

        // 确保循环索引始终正确（-1 = 最后一张，+1 = 下一张）
        const position = offset < 0 ? offset + total : offset % total;

        // 根据位置设置对应的样式
        if (position === 0) {
          return { transform: "translateX(0) scale(1.2)", zIndex: 3, transition: "all opacity 5s linear" };
        } else if (position === 1) {
          return { transform: "translateX(30.5rem) scale(0.8)", zIndex: 1, transition: "all opacity 5s ease-in-out" };
        } else if (position === 2) {
          return { transform: "translateX(16.75rem) scale(0.95)", zIndex: 2, transition: "all opacity 5s ease-in-out" };
        } else if (position === total - 1) {
          return { transform: "translateX(-30.5rem) scale(0.8)", zIndex: 1, transition: "all opacity 5s ease-in-out" };
        } else if (position === total - 2) {
          return { transform: "translateX(-16.75rem) scale(0.95)", zIndex: 2, transition: "all opacity 5s ease-in-out" };
        } else {
          return { display: "none" }; // 其他图片隐藏
        }
      },
      //获取数据
      async getTypeList() {
        this.treeData = [];
        this.currentImg = [];
        getDataInfo({ strType: 'aboutUs' }).then(res => {
          if (res.data.length == 0) {
            // console.log(this.treeData)
          }
          else {
            let firstNode = {
              id: 0,
              name: 'Sanmak',
              url: '',
              children: []
            }
            res.data.forEach(element => {
              let secNode = { id: element.id, name: element.name, url: element.url, children: [] }
              firstNode.children.push(secNode);
              // this.currentImg.push({url:'../../../assets/img/About/'+element.url})
            });
            this.treeData.push(firstNode);
          }

          if (this.treeData.length > 0) {
            if (this.$route.params.id != undefined) {
              var node = this.treeData[0].children.filter(item => item.id == this.$route.params.id)
              this.$nextTick(() => {
                this.$refs.treeleft.setCurrentKey(node[0].id);
              });

              this.currentImg.push({ url: '../../../assets/img/About/' + node[0].url })
            }
            else {
              this.$nextTick(() => {
                this.$refs.treeleft.setCurrentKey(this.treeData[0].children[0].id);
              });

              this.currentImg.push({ url: '../../../assets/img/About/' + this.treeData[0].children[0].url })
            }
          }
        })
      },
      handleNodeClick(data, node, tree) {
        console.log('Node clicked:', data, node, tree);

        // 在这里处理节点点击的逻辑
        // this.currentImg = [];
        // if (node.data.url.length == 0) {
        //   data.children.forEach(element => {
        //     if (element.url.length > 0) {
        //       this.currentImg.push({ url: '../../../assets/img/About/' + element.url })
        //     }
        //   });
        // }
        // else {
        //   this.currentImg.push({ url: '../../../assets/img/About/' + node.data.url })
        // }
        if (node.data.id == 0) {
          this.firstPage = true;
          this.secondPage = true;
          this.thirdPage = true;
          this.fourthPage = true;
          this.fifthPage = true;
          this.sixthdPage = true;
          this.seventhPage = true;
          this.eighthPage = true;
        }
        else {
          this.firstPage = node.data.id == 1 ? true : false;
          this.secondPage = node.data.id == 2 ? true : false;
          this.thirdPage = node.data.id == 3 ? true : false;
          this.fourthPage = node.data.id == 4 ? true : false;
          this.fifthPage = node.data.id == 5 ? true : false;
          this.sixthdPage = node.data.id == 6 ? true : false;
          this.seventhPage = node.data.id == 7 ? true : false;
          this.eighthPage = node.data.id == 8 ? true : false;
        }
        if (this.eighthPage) {
           try {
                    getRecruitData().then(res => {
                        if (res.data.length == 0) {
                            this.currentRow = { id: 0, firstTitle: '', secondTitle: '', thirdTitle: '', content: '', remark: '' }
                        }
                        else {
                            this.currentRow = res.data[0]
                        }
                    })
                } catch (error) {
                    console.error('获取失败:', error);
                }
        }
      },
    },
    mounted() {
      this.getTypeList();
    },
  };
</script>

<style scoped>
  @import '../../assets/css/main.css';

  .tree-line {
    background-color: transparent;
    color: #D3D3D2;
  }

  ::v-deep .el-tree-node.is-current>.el-tree-node__content {
    background: #FCB42E !important;
    color: black;
  }

  /* ::v-deep .el-tree-node > .el-tree-node__content .name-box:first-child  {
  color: rebeccapurple !important;
} */
  /* ::v-deep .el-tree > .el-tree-node > .el-tree-node__content {
  pointer-events: none;
} */
  /* ::v-deep .el-tree-node:first-of-type  {
  color: red;
} */

  :deep(.carousel) {
    position: relative;
    width: 100%;
    height: 35rem;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  :deep(.carousel-wrapper) {
    position: relative;
    width: 17rem;
    height: 35rem;
    display: flex;
    align-items: center;
    justify-content: center;
    perspective: 1000px;
  }

  :deep(.carousel-item) {
    position: absolute;
    width: 17rem;
    height: 32rem;
    transition: transform 0.5s ease, z-index 0.5s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  :deep(.carousel-item img) {
    width: 100%;
    height: auto;
  }

  :deep(.custom-svg-img) {
    filter: brightness(0) saturate(100%) invert(26%) sepia(0%) saturate(138%) hue-rotate(273deg) brightness(93%) contrast(96%)
  }

  :deep(img) {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  :deep(.introduction_img) {
    max-height: 24rem;
  }

  :deep(.introduction_text) {
    position: relative;
    display: flex;
    max-height: 24rem;
    overflow-x: hidden;
  }

  :deep(.introduction_text::-webkit-scrollbar) {
    width: 0.2rem;
  }

  :deep(.introduction_text::-webkit-scrollbar-thumb) {
    background-color: #FCB42E;
    border-radius: 4px;
  }

  :deep(.introduction_text::-webkit-scrollbar-thumb:hover) {
    background-color: #FCB42E;
  }

  :deep(.introduction_text::-webkit-scrollbar-track) {
    background-color: #606060;
    border-radius: 4px;
  }

  :deep(hr) {
    color: #3E3E3D;
    background-color: #3E3E3D;
    height: 1px;
  }

  :deep(.photo-group) {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
  }

  :deep(.photo-container) {
    text-align: left;
    position: relative;
    width: 14.7rem;
    line-height: 2.2rem;
    cursor: pointer;
  }

  :deep(.photo-container h3) {
    color: #FCB42E;
  }

  :deep(.photo-container span) {
    font-size: 16px;
    font-weight: lighter;
  }

  :deep(.course-group) {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
  }

  :deep(.course-container) {
    place-items: center;
    text-align: left;
    position: relative;
    width: 14.7rem;
    line-height: 2.2rem;
    cursor: pointer;
  }

  :deep(.course-container .dot) {
    height: 1rem;
    width: 1rem;
    border-radius: 50%;
    background-color: #fff;
    top: 2.4rem;
    left: 45%;
    position: absolute;
  }

  :deep(.course-container .course-content) {
    background-color: #454545;
    width: 10.5rem;
    height: 13.75rem;
    border-radius: 4px;
    place-items: center
  }

  :deep(.course-content>div) {
    background-color: #FCB42E;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    text-align: center;
    margin: 0 auto;
  }

  :deep(.course-content>div img) {
    padding: 10px;
    filter: brightness(0) saturate(100%) invert(26%) sepia(0%) saturate(138%) hue-rotate(273deg) brightness(93%) contrast(96%)
  }

  :deep(.course-content>p) {
    overflow: hidden;
    font-size: 15px;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }

  :deep(.course-container .course-content p) {
    font-size: 14px;
    line-height: 1.2rem;
  }

  :deep(.course-container:hover h4) {
    color: #FCB42E;
    transition: color 0.5s ease;
  }

  .course-container:hover .dot,
  .course-container:hover .course-content {
    background-color: #FCB42E;
    transition: background-color 0.5s ease;
  }

  :deep(.course-container:hover .course-content>div) {
    background-color: #fff;
    transition: background-color 0.5s ease;
  }

  :deep(.course-container:hover .course-content>div img) {
    filter: brightness(0) saturate(100%) invert(87%) sepia(41%) saturate(3489%) hue-rotate(335deg) brightness(104%) contrast(98%);
  }

  :deep(.control) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 24px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    cursor: pointer;
    z-index: 20;
  }

  :deep(.control.left) {
    left: 10%;
  }

  :deep(.control.right) {
    right: 10%;
  }

  :deep(.control:hover) {
    background: rgba(0, 0, 0, 0.8);
  }

  :deep(.certificate) {
    display: flex;
    align-items: center;
    padding: 1.2rem 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
</style>